// Port of api/fuel/app/classes/insights/ratings/designers.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'designers',
    priority: 1,
    default_: true,
    requires: [],
    insight: [],
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_ratings()) return {}

        var self = this

        var limit = detail ? 100 : 5
        var threshold = (owner.get_threshold() * 2) + 1

        var ranked = []

        var filterType = (filter.designers !== undefined) ? filter.designers : 'best'

        var ratingRows = Util.queryFast('\
            SELECT \
                r.game_id AS game, \
                AVG(r.rating_value) AS rating, \
                COUNT(r.rating_id) AS ratings \
            FROM \
                rating r \
                JOIN \
                game g \
            WHERE \
                r.game_id = g.game_id \
                AND \
                g.game_type = 1 \
                AND \
                r.user_id IN (' + Util.in(userIndex) + ') \
            GROUP BY \
                g.game_id \
        ')
        var ratings = {}
        var ratingIndex = []
        for (var rri = 0; rri < ratingRows.length; rri++) {
            var rrow = ratingRows[rri]
            ratings[rrow.game] = rrow
            ratingIndex.push(rrow.game)
        }

        if (ratingIndex.length) {

            var applicable = Util.queryFast('\
                SELECT \
                    l.game_id AS game, \
                    l.designer_id AS designer \
                FROM \
                    game_designer l \
                WHERE \
                    l.game_id IN (' + Util.in(ratingIndex) + ') \
            ')

            var grouped = {}

            for (var i = 0; i < applicable.length; i++) {
                var link = applicable[i]
                var dKey = link.designer
                var game_id = link.game
                var ratingRow = ratings[game_id]
                if (!ratingRow) continue

                var entry = grouped[dKey]
                if (!entry) {
                    entry = grouped[dKey] = {
                        designer: dKey | 0,
                        games: [],
                        rating: 0,
                        ratings: 0,
                        average: 0
                    }
                }

                var rrCount = ratingRow.ratings | 0
                entry.games.push(game_id | 0)
                entry.ratings += rrCount
                entry.rating += rrCount * ratingRow.rating
                entry.average = entry.rating / entry.ratings
            }

            // filter by threshold
            var filteredGroups = {}
            var gkeys = Object.keys(grouped)
            for (var fi = 0; fi < gkeys.length; fi++) {
                if (grouped[gkeys[fi]].ratings >= threshold) {
                    filteredGroups[gkeys[fi]] = grouped[gkeys[fi]]
                }
            }

            var filteredArray = Object.keys(filteredGroups).map(function(k) { return filteredGroups[k] })

            if (filteredArray.length) {

                var sorted = filteredArray.slice().sort(function(a, b) {
                    if (filterType === 'best') {
                        if (a.average !== b.average) return b.average - a.average
                        if (a.ratings !== b.ratings) return b.ratings - a.ratings
                    } else {
                        if (a.ratings !== b.ratings) return b.ratings - a.ratings
                        if (a.average !== b.average) return b.average - a.average
                    }
                    return a.designer - b.designer
                })

                sorted = sorted.slice(0, limit)

                // get all designers via raw query (was Designer.where().associated())
                var designerIds = Util.pluck(sorted, 'designer')
                var detailRows = Util.queryFast(
                    'SELECT designer_id, designer_name FROM designer WHERE designer_id IN(' + Util.in(designerIds) + ')'
                )
                var details = {}
                for (var dr = 0; dr < detailRows.length; dr++) {
                    details[detailRows[dr].designer_id] = detailRows[dr]
                }

                for (var si = 0; si < sorted.length; si++) {
                    var item = sorted[si]

                    var gameRatings = []

                    for (var gi = 0; gi < item.games.length; gi++) {
                        var gid = item.games[gi]
                        gameRatings.push({
                            id: gid,
                            rating: (ratings[gid] && ratings[gid].rating !== undefined) ? parseFloat(ratings[gid].rating) : '-'
                        })
                    }

                    gameRatings = gameRatings.sort(function(a, b) {
                        if (a.rating !== b.rating) return b.rating - a.rating
                        return a.id - b.id
                    })

                    for (var rri2 = 0; rri2 < 3 && rri2 < gameRatings.length; rri2++) {
                        self._references.games.push(gameRatings[rri2].id)
                    }

                    var detail = details[item.designer]
                    ranked.push({
                        id: detail ? (detail.designer_id | 0) : item.designer,
                        name: detail ? (detail.designer_name || '') : '',
                        count: item.ratings,
                        rating: Math.round(item.average * 10) / 10,
                        games: gameRatings.slice(0, 3),
                        gamesCount: item.games.length
                    })
                }

            }

        }

        return {
            designers: ranked
        }

    }
})
